import { render, staticRenderFns } from "./TotalAmountsBase.vue?vue&type=template&id=2519eca1&scoped=true&"
import script from "./TotalAmountsBase.vue?vue&type=script&lang=js&"
export * from "./TotalAmountsBase.vue?vue&type=script&lang=js&"
import style0 from "./TotalAmountsBase.vue?vue&type=style&index=0&id=2519eca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519eca1",
  null
  
)

export default component.exports